import { ApiKey, BaseUrl } from '../global'
import axios from 'axios'

export const login = async (user, pass) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/GetUser', {
            userId: user,
            password: pass
        }, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        return { ok: false, msg: e }
    }
}

export const changePassword = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/ChangePassword', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}